export function toFriendlyBookingError(err) {
    const rawMessage =
        (err?.graphQLErrors?.[0]?.message) ||
        (err?.networkError?.result?.errors?.[0]?.message) ||
        err?.message || '';
    const cleaned = rawMessage
        .replace('GraphQL error: ', '')
        .replace(/^SafeError\s*/, '');

    let friendly = cleaned;

    // Pattern: "<uuid> conflicts with this booking"
    if (/conflicts with this booking/i.test(cleaned)) {
        friendly = 'This vehicle plate already has an active booking that overlaps with the dates you selected. Please use a different plate or cancel the existing booking.';
    } else if (/Guest Card is expired/i.test(cleaned)) {
        friendly = 'This guest card has expired and can no longer be used to create bookings.';
    } else if (/Booking data is not acceptable/i.test(cleaned)) {
        friendly = 'Some required guest card fields are missing. Please fill in all required fields and try again.';
    } else if (/Stripe Rate Card requires confirmed payment/i.test(cleaned)) {
        friendly = 'A confirmed payment method is required for this guest card. Please complete the payment details.';
    } else if (/Plate mismatch/i.test(cleaned)) {
        friendly = 'The licence plate does not match the gate entry event.';
    } else if (/Session exceeds the .* limit/i.test(cleaned)) {
        friendly = cleaned;
    } else if (cleaned) {
        friendly = cleaned;
    }

    return Object.assign(new Error(friendly), {
        message: friendly,
        graphQLErrors: [{ message: friendly }],
        networkError: err?.networkError,
    });
}
